import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import { CART_NOTIFICATIONS } from "constants/action-types";
import { postToLegacyIframe, postToShipmentReviewIframe } from "helpers/window-messages";
import { GRID_VIEW_NOTIFICATION, IFRAME_REDUX_ACTION } from "constants/cart";
import { INotification } from "reducers/cart-notifications";

export const cartNotificationsAddEpic = (action$, store) =>
    action$.ofType(CART_NOTIFICATIONS.ADD).mergeMap(({ payload }) => {
        const { active, dismissed } = store.getState().cartNotifications;
        const updated = { ...store.getState().cartNotifications };

        if (
            !_.find(active, ({ id, message }) => id === payload.id || message === payload.message) &&
            !_.includes(dismissed, payload.id)
        ) {
            updated.active = [
                ...active,
                {
                    ...payload,
                    id: payload.id ?? uuidv4(),
                },
            ];
        }

        return [
            {
                type: CART_NOTIFICATIONS.UPDATE,
                payload: updated,
            },
        ];
    });

export const cartNotificationsDismissEpic = (action$, store) =>
    action$.ofType(CART_NOTIFICATIONS.DISMISS).mergeMap(({ payload: id }) => {
        return [
            {
                type: CART_NOTIFICATIONS.UPDATE,
                payload: {
                    active: _.filter(
                        store.getState().cartNotifications.active,
                        (notification) => id !== notification.id
                    ),
                    dismissed: _.uniq([...store.getState().cartNotifications.dismissed, id]),
                },
            },
        ];
    });

export const cartNotificationsRemoveEpic = (action$, store) =>
    action$.ofType(CART_NOTIFICATIONS.REMOVE).mergeMap(({ payload: ids }) => {
        return [
            {
                type: CART_NOTIFICATIONS.UPDATE,
                payload: {
                    active: _.differenceWith(
                        store.getState().cartNotifications.active,
                        ids,
                        (acive: INotification, id: string) => acive.id === id
                    ),
                    dismissed: store.getState().cartNotifications.dismissed,
                },
            },
        ];
    });

export const cartNotificationsResetEpic = (action$, store) =>
    action$.ofType(CART_NOTIFICATIONS.RESET).mergeMap(() => {
        postToShipmentReviewIframe({
            action: IFRAME_REDUX_ACTION,
            payload: {
                type: CART_NOTIFICATIONS.UPDATE,
                payload: store.getState().cartNotifications,
            },
        });
        return [
            {
                type: CART_NOTIFICATIONS.UPDATE,
                payload: { ...store.getState().cartNotifications, active: [], dismissed: [] },
            },
        ];
    });

export const cartNotificationsSyncEpic = (action$, store) =>
    action$.ofType(CART_NOTIFICATIONS.UPDATE, CART_NOTIFICATIONS.SYNC).mergeMap(() => {
        postToLegacyIframe({
            action: GRID_VIEW_NOTIFICATION.UPDATE,
            payload: store.getState().cartNotifications,
        });
        postToShipmentReviewIframe({
            action: IFRAME_REDUX_ACTION,
            payload: {
                type: CART_NOTIFICATIONS.UPDATE,
                payload: store.getState().cartNotifications,
            },
        });
        return [];
    });
